import imgixConfig from 'Config/imgix';

// [width, height] of each crop, as wide and short as the banner (Styles/base/global.scss .facet-header-img-container)
const CROPS = [
  [5000, 400],
  [4250, 340],
  [3600, 285],
  [2500, 200],
  [1800, 200],
  [1520, 179],
  [1200, 143],
  [992, 107],
  [768, 79],
];

/**
 * The srcset and fallback src of a facet page's header image. Shared by FacetHeaderBanner and its skeleton
 * (Features/FacetCategory/skeletons/FacetPageSkeleton), so both request the same URLs.
 * @param  {String} bgImgSrc Absolute image URL
 * @return {Object} { srcSet, src }
 */
export default function headerBannerSources(bgImgSrc) {
  const toUrl = (width, height) => `${bgImgSrc}?${imgixConfig}&w=${width}&h=${height}&fit=crop`;

  return {
    srcSet: CROPS.map(([width, height]) => `${toUrl(width, height)} ${width}w`).join(', '),
    src: toUrl(1800, 200),
  };
}
